import { QUERY_KEYS, useFilter } from '@monorepo/helpers';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';
import { useQuery } from '@tanstack/react-query';
import { ListCounterpartyResponse } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';

const useGetClientsList = (id: string) => {
  const { filter } = useFilter();
  const request = useGetRequest(REQUEST_TYPES.GET_CLIETNS_LIST);

  return useQuery<ListCounterpartyResponse.AsObject, TGRPCPromiseReject>({
    queryKey: [QUERY_KEYS.LIST_CLIENTS, { ...filter, id }],
    queryFn: request,
    refetchOnWindowFocus: false,
    enabled: !!id
  });
};

export default useGetClientsList;
